module["exports"] = ["dipl.oecc", "dipl.ing"];